<template>
    <div v-loading="pageLoading">
        <el-form :model="formData" :rules="rules" ref="formData" label-position="top">
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="名称:">
                        <el-input placeholder="请填写名称" v-model="formData.title" maxlength="40" size="medium"></el-input>
                    </el-form-item>
					<el-form-item prop="category" label="首页展示位置:">
					   <el-select v-model="formData.category" placeholder="不限制位于首页分类的位置" class="fl fl-big-select" clearable size="small">
					       <el-option v-for="(item, index) in category" :label="item.name == '推荐' ? '位于首页推荐分类' : '仅看位于首页'+item.name+'分类的' " :key="index" :value="item.id"></el-option>
					   </el-select>
					</el-form-item>

                    <el-form-item prop="cites" v-if="!formData.id">
                        <!-- <div class="form-flex">
                            <city-select :value.sync="formData.cites" :value-options="cityOptions" :multiple="!id">
                            </city-select>
                        </div>
                        <small class="MT10">
                            <span class="el-icon-warning"></span>
                            如果需要全国展示,请选择【全国】。
                            如果填写了多个展示城市,系统会为每个城市创建单独的Banner
                        </small> -->						
						<el-form-item prop="settingType" >
							<span slot="label"><span class="color-danger">*</span> 展示城市:</span>
						    <el-radio-group v-model="formData.settingType">
						        <el-radio :label="0">全国展示</el-radio>
						        <el-radio :label="1">只在下面地区展示</el-radio>
						        <!-- <el-radio :label="2"><span style="color:#F56C6C">不在</span>下面地区展示</el-radio> -->
						    </el-radio-group>
						</el-form-item>
						<el-form-item prop="sellArea" v-if="formData.settingType != 0">
						    <span slot="label">地区设置:</span>
						    <el-cascader v-model="sellArea" :options="cityList" filterable
						        :props="{ label: 'name', children: 'cityList', value: 'id', multiple: true, checkStrictly: true }"
						        style="width:100%" ref="cityCascader">
						    </el-cascader>							
							<small class="MT10 red">							   
								如果指定了多个城市，系统会为每个城市创建单独的Banner<br>如果同时设置了省份和省份下的某个城市展示，则全省展示<br>如果同时设置了省份和省份下的某个城市不展示，则全省不展示
							</small>
						</el-form-item>						
                    </el-form-item>
					<el-form-item prop="cites" v-else>
						<el-form-item prop="city">
							<span slot="label"><span class="color-danger">*</span> 展示城市:</span>
						    <city-select :value.sync="formData.cites" :value-options="cityOptions"  :multiple="!id"></city-select>
						    <small class="MT10 red">
						        <span class="el-icon-warning"></span> 如果需要全国展示，请填写【全国】
						    </small>
						</el-form-item>
					</el-form-item>
                    <el-form-item prop="jumpValue" v-if="!id" label="跳转目标:">
                        <el-input v-model="formData.jumpValue" :maxlength="formData.jumpType === 3 ? 200 : 10"
                            class="input-with-select" @input="onInput"
                            :placeholder="formData.jumpType === 3 ? '请填写链接' : formData.jumpType === 4 ? '请填写立减活动ID' : formData.jumpType === 1 ? '请填写演出ID' : '请填写巡演ID'"
                            size="medium">
                            <el-select v-model="formData.jumpType" slot="prepend" @change="resetActivityEndTime"
                                placeholder="请选择">
                                <el-option label="演出" :value="1"></el-option>
                                <el-option label="巡演" :value="2"></el-option>
								<el-option label="立减活动" :value="4"></el-option>
                                <el-option label="普通链接" :value="3"></el-option>
                            </el-select>
                            <el-button slot="append" :loading="jumpLoading" @click="verifyJump">跳转解析</el-button>
                        </el-input>
                        <el-alert v-if="jumpText" :title="jumpText" type="info" show-icon :closable="false"></el-alert>
                        <el-table v-if="jumpActivities.length" :data="jumpActivities" style="width: 100%" border size="mini">
                            <el-table-column prop="title" label="演出名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="ticketName" label="最早开票票品" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="startTime" label="开票时间" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </el-form-item>
                    <el-form-item prop="url" v-else label="跳转链接:">
                        <el-input placeholder="请填写跳转链接" v-model="formData.url" maxlength="200" size="medium"></el-input>
                    </el-form-item>

                    <template v-if="formData.jumpType === 2 && isVerifyJump">
                        <el-form-item prop="tourJumpRule" label="巡演跳转规则:">
                            <el-radio @change="resetActivityEndTime" v-model="formData.tourJumpRule" :label="1">
                                巡演所含城市的Banner跳转至各自演出详情页，其余城市的Banner跳转至巡演列表页</el-radio>
                            <el-radio @change="resetActivityEndTime" v-model="formData.tourJumpRule" :label="2">
                                所有城市的Banner统一跳转至巡演列表页</el-radio>
                        </el-form-item>
                    </template>

                    <el-form-item prop="time" label="展示时间段1:">
                        <div class="form-flex">
                            <el-date-picker v-model="formData.time" type="datetimerange" range-separator="至"
                                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                                start-placeholder="开始日期" end-placeholder="结束日期"
                                :disabled="formData.isActivityEndTime === 1" unlink-panels size="medium">
                            </el-date-picker>
                        </div>
                        <div class="form-flex">
                            <el-checkbox v-if="formData.tourJumpRule === 1 && formData.jumpType === 2 && isVerifyJump"
                                checked v-model="formData.isActivityEndTime" :true-label="1" :false-label="2">
                                各站展示结束时间以演出结束时间为准</el-checkbox>
                        </div>
                    </el-form-item>

                    <el-form-item prop="time1" label="展示时间段2:">
                        <div class="form-flex">
                            <el-date-picker v-model="formData.time1" type="datetimerange" range-separator="至"
                                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                                start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
                            </el-date-picker>
                        </div>
                    </el-form-item>

                    <el-form-item prop="time1" label="展示时间段3:">
                        <div class="form-flex">
                            <el-date-picker v-model="formData.time2" type="datetimerange" range-separator="至"
                                value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']"
                                start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels size="medium">
                            </el-date-picker>
                        </div>
                        <small class="MT10">
                            <span class="el-icon-warning"></span> 最晚的展示时间段到期后，Banner会被自动隐藏
                        </small>
                    </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :xl="8">

                    <!-- <el-form-item prop="sourcePath" label="老版本 WAP/APP端静态图:">
                        <image-upload :url.sync="formData.sourcePath" :urlFull.sync="formData.sourcePath" :width="1125" :height="470"></image-upload>
                    </el-form-item> -->
					<el-form-item prop="newSourcePath" label="APP/WAP/WEB端静态图:">
					    <image-upload :url.sync="formData.newSourcePath" :urlFull.sync="formData.newSourcePath" :width="1114" :height="200"></image-upload>
					</el-form-item>

                    <!-- <el-form-item prop="sourceWebPath" label="WEB端静态图:">
                        <image-upload :url.sync="formData.sourceWebPath" :urlFull.sync="formData.sourceWebPath" crop
                            :width="1200" :height="400"></image-upload>
                    </el-form-item> -->

                    <el-form-item prop="dynamicPath" label="APP端动态图:">
                        <image-upload :url.sync="formData.dynamicPath" :urlFull.sync="formData.dynamicPath"
                            accept="image/gif"></image-upload>
                    </el-form-item>
                    <el-form-item prop="terminal" label="展示终端:">
                        <el-checkbox v-model="formData.terminal" :label="3">APP</el-checkbox>
                        <el-checkbox v-model="formData.terminal" :label="2">WAPCN</el-checkbox>
                        <el-checkbox v-model="formData.terminal" :label="4">WAPEN</el-checkbox>
                        <el-checkbox v-model="formData.terminal" :label="1">WEB</el-checkbox>
                    </el-form-item>
                    <el-form-item prop="isShow" label="状态:">
                        <el-select v-model="formData.isShow" placeholder="请选择">
                            <el-option label="展示" :value="1"></el-option>
                            <el-option label="隐藏" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="图片标签:">
                        <el-select v-model="formData.tagType" placeholder="请选择">
                            <el-option label="无" value=""></el-option>
                            <el-option label="演出" :value="1"></el-option>
                            <el-option label="众筹" :value="2"></el-option>
                            <el-option label="周边" :value="3"></el-option>
                            <el-option label="视频" :value="4"></el-option>
                            <el-option label="直播" :value="5"></el-option>
                            <el-option label="广告" :value="6"></el-option>
                            <el-option label="活动" :value="7"></el-option>
                            <el-option label="其他" :value="8"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item v-if="id" prop="isBatchUpdate">
                <span slot="label">
                    批量更新：
                    <el-checkbox v-model="formData.isBatchUpdate" :true-label="1" :false-label="0"
                        @change="batchUpdateFlagChange">开启批量更新</el-checkbox>
                </span>
            </el-form-item>
            <BatchUpdate v-if="formData.isBatchUpdate === 1" :formData.sync="formData" :queryValue="title"></BatchUpdate>

            <el-form-item class="MT20">
                <el-button @click="goBack()">返回</el-button>
                <el-button type="primary" @click="onSubmit" :loading="btnLoading">确认提交</el-button>
                <el-button v-if="id" type="danger" @click="del">删除</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
import CitySelect from '@/components/CitySelect';
import dayjs from 'dayjs'; // 导入日期js
import BatchUpdate from './components/batchUpdate';
import { fetchAllCity } from '@/assets/js/commonApi'
const JUMP_TEXT = [
    '将会跳转至演出详情页，展示城市已自动填写完成',
    '请进一步设置巡演跳转规则，展示城市已自动填写完成',
    '将会跳转至对应链接，请填写展示城市'
];
export default {
    components: {
        CitySelect,
        ImageUpload,
        BatchUpdate
    },
    data() {
        return {
            id: this.$route.params.id,
			timeCalendar:this.$route.params.time,
            formData: {
                jumpType: 1,
                cites: this.$route.params.id ? '' : [],
                tourJumpRule: 1,
                // sourcePath: '',
                time: [],
                terminal: [],
                title: '',
                // sourceWebPath: '',
				newSourcePath:'',
                dynamicPath: '',
                tagType: '',
                isShow: 1,
                isActivityEndTime: 2,
                time1: [],
                time2: [],
                contents: [],
                ids: [],
                isBatchUpdate: 0,
				settingType:0
            },
            rules: {
                isShow: [{ required: true, message: "请选择状态" }],
                title: [{ required: true, message: "请填写名称" }],
				category: [{ required: true, message: "请选择演出分类" }],
                jumpValue: [{ required: true, message: "请填写跳转目标，并进行解析" }],
                //cites: [{ required: true, message: "请选择城市" }],
                terminal: [{ required: true, message: "请选择勾选展示终端" }],
                // sourceWebPath: [{ required: true, message: "请设置WEB端静态图" }],
                // sourcePath: [{ required: true, message: "请设置老版WAP/APP端静态图" }],
				newSourcePath: [{ required: true, message: "请设置新版WAP/APP端静态图" }],
                url: [{ required: true, message: "请设置跳转链接" }],
            },
            cityAll: false,
            cityOptions: [],
            jumpText: '',
            jumpActivities: [],
            jumpLoading: false,
            btnLoading: false,
            pageLoading: false,
            isVerifyJump: false,
            endTime: '',
            redirect: this.$route.query.redirect || '',
            title: "",
			cityList: [],
			sellArea:[],
			category:[]
        };
    },
    mounted() {
		this.getCategory()
        if (this.id) {
            this.getDetail();
        }
		if (this.timeCalendar){			
			this.formData.time = [this.timeCalendar + ' 00:00:00' || '', this.timeCalendar + ' 23:59:59' || ''];			
		}
    },
	async created() {
		await this.getCityList();
		
	},
    methods: {
        //返回
        goBack() {
            if (this.redirect) {
                this.$router.push({
                    path: this.redirect,
                });
            } else {
                this.$router.go(-1);
            }
        },
		//获取演出分类
		getCategory() {
		    this.$request({
		        url: "/banner/category",
		        method: "post",
		        
		    }).then(res => {
		        const { state, result } = res.data;
		        if (state == 1) {
		            this.category = result || []
		        }
		    })
		},
		//获取城市列表
		async getCityList() {
		    const res = await fetchAllCity({}).catch(() => { });
		    const { state, result } = res.data;
		    if (state == 1) {
		        this.cityList = result;
		    }
		},
        //  验证跳转值
        async verifyJump() {
            if (!this.formData.jumpValue) return this.$message.error('请填写需要验证的内容');
            if (this.formData.jumpType === 3) return this.jumpText = JUMP_TEXT[this.formData.jumpType - 1];
            this.isVerifyJump = false;
            this.jumpLoading = true;
            this.jumpText = '';
            this.jumpActivities = [];
            const response = await this.$request({
                url: "/banner/jumpResolution",
                method: "POST",
                data: { jumpType: this.formData.jumpType, jumpValue: this.formData.jumpValue },
            });
            const { state, msg, result } = response.data;
            this.jumpLoading = false;
            if (state != 1) return this.$message.error(msg);
            this.jumpText = JUMP_TEXT[this.formData.jumpType - 1];
            this.jumpActivities = result.activities || [];
            this.isVerifyJump = true;
            this.endTime = result.endTime;
            this.resetActivityEndTime();			
			
			if (result.cites && result.cites.length > 0) {
				this.sellArea = []
				if( this.formData.jumpType == 2 ){							
					const cityCodesxy = [];
					result.cites.forEach(function (item, index) {				       
						cityCodesxy.push([item.pcode, item.code]);
					})
					this.sellArea = cityCodesxy;
					
				}								
			    this.cityOptions = result.cites.map(city => {
					if( this.formData.jumpType == 1 ){
						const cityCodes = [];	
						cityCodes.push(city.pcode,city.code);
						this.formData.cityCodes = cityCodes;
						var citycodes2 = []
							citycodes2.push(cityCodes)
							this.sellArea = citycodes2;
					}					
					return { value: city.pcode, label: city.name }
				});
				this.formData.settingType = 1
			}
			
        },
        resetActivityEndTime() {
            if (this.formData.jumpType !== 2 || this.formData.tourJumpRule !== 1) {
                this.formData.time = [dayjs().hour(0).minute(0).second(0).format('YYYY-MM-DD HH:mm:ss'), this.endTime]
                this.formData.isActivityEndTime = 2;
            } else {
                this.formData.time = [];
            }
        },
        // 获取详情
        async getDetail() {
            this.pageLoading = true;
            const response = await this.$request({
                url: "/banner/getDetail",
                method: "POST",
                params: { id: this.id },
            });
            this.pageLoading = false;

            const { msg, state, result } = response.data;
            if (state != 1) return this.$message.error(msg);

            if (result.cityCode && result.cityCode != 0) {
                result.cites = result.cityCode.toString();
                this.cityOptions = [{ value: result.cityCode.toString(), label: result.cityName }];
            } else {
                result.cites = '0';
            }
            if (result.terminal) result.terminal = result.terminal.split(',').map(item => parseInt(item));
            if (result.autoDeleteTime && result.startDate) result.time = [result.startDate, result.autoDeleteTime];
            this.formData = { ...this.formData, ...result };

            this.formData.time1 = [result.firstStartDate || '', result.firstEndDate || ''];
            this.formData.time2 = [result.secondStartDate || '', result.secondEndDate || ''];

            this.title = result.title;
        },
        //表单提交
        onSubmit() {
			if( this.formData.settingType != 0 && this.sellArea.length == 0 && !this.id ){
				this.$message.warning('展示城市不能为空');
				return
			}
			
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    //if (this.$route.params.id && this.formData.cites === '') return this.$message.error('请先解析跳转目标');
                    //if (!this.$route.params.id && this.formData.cites.length === 0) return this.$message.error('请先解析跳转目标');
                    this.btnLoading = true;
                    const form = JSON.parse(JSON.stringify(this.formData));
                    if (form.time && form.time.length === 2) {
                        form.startDate = form.time[0];
                        form.autoDeleteTime = form.time[1];
                    } else {
                        form.startDate = '';
                        form.autoDeleteTime = '';
                    }

                    form.firstStartDate = form.time1 && form.time1[0] || '';
                    form.firstEndDate = form.time1 && form.time1[1] || '';
                    form.secondStartDate = form.time2 && form.time2[0] || '';
                    form.secondEndDate = form.time2 && form.time2[1] || '';

                    form.terminal = form.terminal.toString();

                    if(form.id){
                        form.batchUpdateTO = {
                            contents: form.contents || [],
                            id: form.id || "",
                            ids: form.ids
                        }
                    }
					
					//const form = JSON.parse(JSON.stringify(this.formData));
					// form.city = form.city.toString();
					if(!form.id){
						form.provinces = [];
						form.cites = [];
						this.sellArea.map(item => {
							if (!form.provinces.find(v => v == item[0]) && !item[1]) {
								form.provinces.push(item[0]);
							}
							item[1] && form.cites.push(item[1]);
						})
					}else{
						const city = JSON.parse(form.cites)
						form.cites=[]
						form.cites.push(city)
						form.cites = form.cites.toString()
					}
					// console.log(form)
					// return;

                    const response = await this.$request({
                        url: this.id ? "/banner/edit" : "/banner/add",
                        method: "POST",
                        data: form
                    });
                    const { msg, state } = response.data;
                    this.btnLoading = false;
                    if (state != 1) return this.$message.error(msg);
                    this.goBack();

                }
            });
        },
        onInput(value) {
            if (this.formData.jumpType === 3) return;
            if (!/^[0-9]+$/.test(value)) this.formData.jumpValue = '';
        },
        //删除演出
        del() {
            const _msg = '确认删除该Banner?';
            this.$confirm(_msg, '删除Banner', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(async () => {
                const response = await this.$request({
                    url: "/banner/delete",
                    method: "POST",
                    params: { id: this.id },
                });
                const { msg, state } = response.data;
                if (state != 1) return this.$message.error(msg);
                this.$message.success('启动页删除成功');
                this.goBack();
            })
        },
        batchUpdateFlagChange(e) {
            if (e === 0) {
                this.formData.ids = [];
                this.formData.contents = [];
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.form-flex {
    display: flex;

    .el-checkbox {
        margin-left: 10px;
    }
}

.el-alert {
    padding: 0px 16px;
}
.red{
		color:#F56C6C
	}
</style>